<template>
  <d-modal @close="handleClose" size="lg">
    <d-modal-header>
      <d-modal-title>
        {{ $t('order.gusComparision.title') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body class="p-0">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <th></th>
            <th scope="col" class="border-0 w-50">
              {{ $t('order.gusComparision.dataFromOrder') }}
            </th>
            <th scope="col" class="border-0 w-50">
              {{ $t('order.gusComparision.dataFromGus') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) of [
              ['invoice_name', 'name'],
              ['invoice_street', 'street'],
              ['invoice_building', 'streetNumber'],
              ['invoice_locale', 'houseNumber'],
              ['invoice_city', 'city'],
              ['invoice_postcode', 'postCode'],
              ['invoice_tax_number', 'taxNumber']
            ]"
            :key="'comparision-data-row-' + index">
            <td style="white-space: nowrap; text-align: right;">
              {{ $t('order.gusComparision.rowTitle.' + item[1]) }}
            </td>
            <td :style="'background-color: ' + (dataForComparision.order[item[0]] === dataForComparision.gus[item[1]] ? '#cfc' : '#fcc') + ';'">
              {{ dataForComparision.order[item[0]] }}
            </td>
            <td :style="'background-color: ' + (dataForComparision.order[item[0]] === dataForComparision.gus[item[1]] ? '#cfc' : '#fcc') + ';'">
              {{ dataForComparision.gus[item[1]] }}
            </td>
          </tr>
        </tbody>
      </table>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        theme="danger"
        class="mr-auto"
        @click.prevent="handleCloseBtn"
        :disabled="updateInProgress">
        {{ $t('ui.close') }}
      </d-button>
      <d-button
        theme="success"
        class="ml-auto"
        :disabled="updateInProgress"
        @click.prevent="updateData">
        {{ $t('order.gusComparision.update') }}
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'order-gus-comparision-popup',
  props: [
    'dataForComparision'
  ],
  data () {
    return {
      updateInProgress: false
    };
  },
  methods: {
    handleClose () {
      this.$bus.$emit('close-gus-comparision-popup');
    },
    handleCloseBtn () {
      if (this.dataForComparision.isExternalCall) {
        this.handleClose();
        this.$bus.$emit('order-check-customer-tax-number-before-invoice', this.dataForComparision.immediate);
      } else {
        this.handleClose();
      }
    },
    updateData () {
      this.updateInProgress = true;
      this.$http.post('/customers/update-invoice-data/' + this.dataForComparision.customerID, {
        invoice_name: this.dataForComparision.gus.name,
        invoice_street: this.dataForComparision.gus.street,
        invoice_postcode: this.dataForComparision.gus.postCode,
        invoice_city: this.dataForComparision.gus.city,
        invoice_building: this.dataForComparision.gus.streetNumber,
        invoice_locale: this.dataForComparision.gus.houseNumber,
        tax_number_verification_id: this.dataForComparision.taxVerificationID,
        invoice_tax_number: this.dataForComparision.gus.taxNumber,
        order_id: parseInt(this.$route.params.id, 10)
      }).then(response => {
        if (response.data.success) {
          Vue.swal({
            title: this.$t('ui.saved'),
            type: 'success',
            confirmButtonText: this.$t('ui.ok'),
            buttonsStyling: true,
            timer: 2000
          });
        }

        this.updateInProgress = false;
        this.$bus.$emit('close-gus-comparision-popup');
        this.$bus.$emit('order-check-customer-tax-number-before-invoice', this.dataForComparision.immediate);
      }).catch(error => {
        console.log(error);

        Vue.swal({
          title: this.$t('ui.errorOccuredDuringSending'),
          html: this.$t('ui.tryAgain'),
          type: 'warning',
          confirmButtonText: this.$t('ui.ok'),
          buttonsStyling: true
        });

        this.updateInProgress = false;
      });
    }
  }
}
</script>
